// import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  modalImage();
  scrollEffect();
});
/* ----------------------------------
  　お問い合わせ関連
---------------------------------- */
// // //お問い合わせバリデーション
if(document.body.classList.contains("contact")){
  topValidation('zip', 'address01', 'address02');
}


gsap.registerPlugin(ScrollToPlugin);

// お問い合わせスクロール
document.addEventListener('tccf7:scrollTo', e => {
  const header = document.querySelector('.header');
  const headerHeight = header ? header.offsetHeight : 0;
  const extraOffset = 100;

  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: headerHeight
    },
    ease: "power2.inOut"
  });
});


/* ----------------------------------
  画像　スクロールアニメーション
---------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const panels = document.querySelectorAll('.is_image-panel');
  if (!panels.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  panels.forEach((el) => observer.observe(el));
});

/* ----------------------------------
  Instagramスライダー
---------------------------------- */
// document.addEventListener('DOMContentLoaded', () => {
//   const isMobile = () => window.innerWidth <= 420;

//   const mobileOptions = {
//     loop: true,
//     centeredSlides: true,
//     slidesPerView: 1.15,
//     spaceBetween: 20,
//     speed: 400,
//     allowTouchMove: true,
//     autoplay: {
//       delay: 3000,
//       disableOnInteraction: false,
//     },
//   };

//   const desktopOptions = {
//     loop: true,
//     slidesPerView: 1.5,
//     spaceBetween: 50,
//     speed: 8000,
//     allowTouchMove: true,
//     autoplay: {
//       delay: 0,
//       disableOnInteraction: false,
//       pauseOnMouseEnter: false,
//     },
//     breakpoints: {
//       480: { slidesPerView: 1.5, spaceBetween: 30 },
//       650: { slidesPerView: 2, spaceBetween: 30 },
//       1025: { slidesPerView: 3, spaceBetween: 40 },
//       1199: { slidesPerView: 4, spaceBetween: 50 },
//     },
//     on: {
//       init: function () {
//         setTimeout(() => { this.update(); }, 2000);
//       },
//     },
//   };

//   let swiper = new Swiper('.news_slider', isMobile() ? mobileOptions : desktopOptions);

//   let resizeTimer;
//   window.addEventListener('resize', () => {
//     clearTimeout(resizeTimer);
//     resizeTimer = setTimeout(() => {
//       swiper.destroy(true, true);
//       swiper = new Swiper('.news_slider', isMobile() ? mobileOptions : desktopOptions);
//     }, 200);
//   });
// });
document.addEventListener('DOMContentLoaded', () => {
  const track = document.getElementById('js-custom-track');
  if (!track) return;

  const startCustomSlider = () => {
    const originalItems = Array.from(track.children);
    const itemCount = originalItems.length;
    
    // 1. 要素を3セット分にする（前・中・後）
    // これにより、左側（前）にもスライドが存在する状態を作ります
    for (let i = 0; i < 2; i++) {
      originalItems.forEach(item => {
        const clone = item.cloneNode(true);
        track.appendChild(clone);
      });
    }

    // Instagram読み込み
    const s = document.createElement('script');
    s.src = "//www.instagram.com/embed.js";
    s.async = true;
    document.body.appendChild(s);

    const gap = parseInt(window.getComputedStyle(track).gap) || 0;
    const itemWidth = track.children[0].offsetWidth;
    const singleSetWidth = (itemWidth + gap) * itemCount; // 1セット分の合計幅

    let currentX = 0;
    let currentIndex = itemCount; // 2セット目の1枚目（インデックスは枚数分進んだところ）からスタート

    // --- 初期位置の設定（読み込み時に真ん中のセットを表示） ---
    const setInitialPosition = () => {
      const screenWidth = window.innerWidth;
      const centerOffset = (screenWidth - itemWidth) / 2;
      // 2セット目の開始位置 + 画面中央寄せ
      currentX = -(currentIndex * (itemWidth + gap)) + centerOffset;
      track.style.transition = 'none';
      track.style.transform = `translateX(${currentX}px)`;
    };

    // --- B. スマホ版（永久ステップループ） ---
    const moveStep = () => {
      if (window.innerWidth > 768) return;

      const screenWidth = window.innerWidth;
      const centerOffset = (screenWidth - itemWidth) / 2;

      currentIndex++;

      // 次のスライドへアニメーション
      track.style.transition = 'transform 0.6s ease-in-out';
      currentX = -(currentIndex * (itemWidth + gap)) + centerOffset;
      track.style.transform = `translateX(${currentX}px)`;

      // アニメーション終了後の処理
      setTimeout(() => {
        // 3セット目の1枚目まで来たら、2セット目の同じ場所にワープ
        if (currentIndex >= itemCount * 2) {
          track.style.transition = 'none';
          currentIndex = itemCount; 
          currentX = -(currentIndex * (itemWidth + gap)) + centerOffset;
          track.style.transform = `translateX(${currentX}px)`;
        }
      }, 600);

      setTimeout(moveStep, 3000);
    };

    // --- A. デスクトップ版（等速フロー） ---
    const animateFlow = () => {
      if (window.innerWidth <= 768) return;
      currentX -= 1.0;
      // 1セット分進んだらリセット（常に真ん中のセットでループさせる）
      if (Math.abs(currentX) >= (singleSetWidth * 2)) {
        currentX = -singleSetWidth;
      }
      track.style.transform = `translateX(${currentX}px)`;
      requestAnimationFrame(animateFlow);
    };

    // 実行
    setInitialPosition();
    if (window.innerWidth <= 768) {
      setTimeout(moveStep, 3000);
    } else {
      // デスクトップ版の初期位置を調整
      currentX = -singleSetWidth; 
      animateFlow();
    }
  };

  // React対策（1.5秒待ってからスライダー化）
  setTimeout(startCustomSlider, 1500);
});

/* ----------------------------------
  初回ローディングアニメーション
---------------------------------- */
if (!sessionStorage.getItem('visited')) {
  window.addEventListener('load', () => {
    const loader = document.getElementById('js-loader');
    setTimeout(() => {
      loader.classList.add('is-hide');
      sessionStorage.setItem('visited', 'true');
    }, 1500);
  });
}
/* ----------------------------------
　ページ遷移アニメーション
---------------------------------- */
const PageTransition = (() => {
  const TRANSITION_CLASS = 'is-transitioning';
  const LOADED_CLASS = 'is-loaded';
  // レイヤー3のdelay(0.2s) + アニメーション時間(0.5s) = 0.7s ぴったりで遷移
  const TRANSITION_DURATION = 700; // ms

  const body = document.body;

  /**
   * ページイン：is-loaded の除去タイマーを開始
   */
  const pageIn = () => {
    // delay(0.2s) + fade_up(0.6s) = 0.8s + 余裕
    setTimeout(() => {
      body.classList.remove(LOADED_CLASS);
    }, 900);
  };

  /**
   * ページアウト（スライドイン）アニメーション
   * スライドイン完了と同時にページ遷移
   * @param {string} url - 遷移先URL
   */
  const pageOut = (url) => {
    body.classList.remove(LOADED_CLASS); // フェード中でも即キャンセル
    body.classList.add(TRANSITION_CLASS);

    // スライドイン完了（0.7s）と同時に遷移
    setTimeout(() => {
      window.location.href = url;
    }, TRANSITION_DURATION);
  };

  /**
   * 内部リンクにイベントを付与
   */
  const bindLinks = () => {
    document.addEventListener('click', (e) => {
      const anchor = e.target.closest('a');

      if (!anchor) return;

      const href = anchor.getAttribute('href');

      // 除外条件
      if (
        !href ||
        href.startsWith('#') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        anchor.target === '_blank' ||
        anchor.hasAttribute('download') ||
        e.ctrlKey || e.metaKey || e.shiftKey
      ) {
        return;
      }

      // 外部リンク除外
      try {
        const url = new URL(href, window.location.href);
        if (url.hostname !== window.location.hostname) return;
      } catch {
        return;
      }

      e.preventDefault();
      pageOut(href);
    });
  };

  /**
   * 初期化
   */
  const init = () => {
    bindLinks();

    // 除去タイマー開始（クラスはスクリプト実行時点で付与済み）
    pageIn();

    // ブラウザの戻る/進む ボタン対応
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        body.classList.remove(TRANSITION_CLASS);
        body.classList.add(LOADED_CLASS);
        pageIn();
      }
    });
  };

  return { init };
})();

document.addEventListener('DOMContentLoaded', () => {
  PageTransition.init();
});


/* ----------------------------------
　humberger menu
---------------------------------- */
window.addEventListener('load', () => {
  const navEle = document.querySelector('.hd_menu-toggle');
  const navWrap = document.querySelector('.hd_nav');
  const navItems = document.querySelectorAll('.hd_nav_list');

  navEle.addEventListener('click', () => {
    const isOpen = navWrap.classList.contains('is_open');

    if (!isOpen) {
      // 開くとき
      navWrap.classList.add('is_open');

      navItems.forEach((item, i) => {
        setTimeout(() => {
          item.classList.add('show');
          item.classList.remove('hide');
        }, i * 120);
      });

    } else {
      // 閉じるとき
      navItems.forEach((item, i) => {
        setTimeout(() => {
          item.classList.remove('show');
        }, i * 80);
      });

      // パネル自体も同時に左へスライド
      navWrap.classList.add('hide-panel');
      setTimeout(() => {
        navWrap.classList.remove('is_open', 'hide-panel');
      }, 500); // CSSトランジション時間に合わせる
    }

    navEle.classList.toggle('is_open', !isOpen);
  });
});

/* ----------------------------------
  FAQ
---------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const faqItems = document.querySelectorAll('.service_faq_item');

  faqItems.forEach((item) => {
    const trigger = item.querySelector('.service_faq_q_wrap');
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      item.classList.toggle('is_open');
    });
  });
});

/* ----------------------------------
  ヘッダー　スクロール固定
---------------------------------- */
window.addEventListener('load', () => {
  const header = document.querySelector('.header');
  const mainimg = document.querySelector('.mainimg');

  if (!header || !mainimg) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting && window.innerWidth > 768) {
        header.classList.add('hd_fixed');
      } else {
        header.classList.remove('hd_fixed');
      }
    },
    { threshold: 0 }
  );

  observer.observe(mainimg);
});
